@if (loaded()) {
  @if (singleSeatProduct() || packageProducts().length > 0) {
    <ct-lib-radio-card-group
      orientation="vertical"
      [value]="selectedOption()"
      (valueChange)="selectedOption.set($event)"
    >
      @if (singleSeatProduct()) {
        <ct-lib-radio-card
          [value]="CUSTOM_AGENTS_OPTION"
          [label]="
            'company-tool.snippets.agents-booking-modal.custom-option-title'
              | transloco
          "
          [price]="customTotalPrice() | currency: 'EUR' : 'symbol' : '1.0-0'"
          [priceHint]="
            'company-tool.snippets.agents-booking-modal.per-month' | transloco
          "
          [disabled]="disabled()"
        >
          <app-number-stepper
            radioCardAction
            [(value)]="customAgentCount"
            [min]="1"
            [max]="50"
            (valueChange)="selectedOption.set(CUSTOM_AGENTS_OPTION)"
          />
          @if (selectedOption() === CUSTOM_AGENTS_OPTION && showPackageHint()) {
            <ct-lib-info-banner
              radioCardFooter
              type="info"
              class="package-hint mb-0"
              @collapse
            >
              <p>
                {{
                  'company-tool.snippets.agents-booking-modal.package-hint'
                    | transloco
                }}
              </p>
            </ct-lib-info-banner>
          }
          @if (isCustomCurrent()) {
            <ct-lib-tag radioCardBadge>{{
              'company-tool.snippets.agents-booking-modal.current-badge'
                | transloco
            }}</ct-lib-tag>
          }
        </ct-lib-radio-card>
      }

      @if (packageProducts().length > 0) {
        <div class="separator-line">
          <span>{{
            'company-tool.snippets.agents-booking-modal.or-select-package'
              | transloco
          }}</span>
        </div>

        @for (product of packageProducts(); track product.id) {
          <ct-lib-radio-card
            [value]="product.id"
            [label]="productTitle(product)"
            [price]="
              monthlyDisplayAmount(product)
                | currency: product.currency.toUpperCase() : 'symbol' : '1.0-0'
            "
            [priceHint]="
              'company-tool.snippets.agents-booking-modal.per-month' | transloco
            "
            [disabled]="disabled()"
          >
            @if (isCurrentPackage(product)) {
              <ct-lib-tag radioCardBadge>{{
                'company-tool.snippets.agents-booking-modal.current-badge'
                  | transloco
              }}</ct-lib-tag>
            }
          </ct-lib-radio-card>
        }
      }
    </ct-lib-radio-card-group>
  }
} @else {
  <div class="loading-wrapper">
    <ngx-skeleton-loader
      appearance="line"
      [theme]="{
        height: '88px',
        width: '100%',
        'border-radius': '15px',
      }"
      count="4"
      [animation]="
        themingService.theme === 'dark' ? 'progress-dark' : 'progress'
      "
    ></ngx-skeleton-loader>
  </div>
}
